import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import WebPlayer from 'web/components/common/WebPlayer';

const PrivateRoute = React.memo(({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={props => {
      const { auth, jwplayer = {}, hasWebplayer = false, isPlayer } = rest;
      // const { handle, player, status, repeatList } = jwplayer;
      // if (auth.user.grade) {
      // 로그인한 유저가 접근할 수 있는 조건
      if (
        !window.isMobile &&
        !hasWebplayer &&
        jwplayer &&
        jwplayer.player &&
        jwplayer.status &&
        jwplayer.status.playing
      ) {
        jwplayer.player.pause();
      }

      if (rest.grade && rest.grade > auth.user.grade) {
        // 로그인은 했지만 권한이 미달되는 조건
        return (
          <Redirect
            to={{
              pathname: '/',
              state: { from: props.location },
            }}
          />
        );
      }

      return (
        <>
          <Component
            {...props}
            hasWebplayer={hasWebplayer}
            jwplayer={jwplayer}
          />
          {!window.isMobile && jwplayer && hasWebplayer ? (
            <WebPlayer
              user={rest.auth.user}
              status={jwplayer.status}
              player={jwplayer.player}
              handle={jwplayer.handle}
              repeatList={jwplayer.repeatList}
              isPlayer={isPlayer}
              pushModal={rest.pushModal}
            />
          ) : null}
        </>
      );
      // } else {
      //   // 비로그인 유저가 로그인이 필요한 페이지에 접근한 조건
      //   return (
      //     <Redirect
      //       to={{
      //         pathname: '/login',
      //         state: { from: props.location },
      //       }}
      //     />
      //   );
      // }
    }}
  />
));

export default PrivateRoute;
